import { render, staticRenderFns } from "./CheckBoxWrapper.vue?vue&type=template&id=f223946e&scoped=true"
import script from "./CheckBoxWrapper.vue?vue&type=script&lang=js"
export * from "./CheckBoxWrapper.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxWrapper.vue?vue&type=style&index=0&id=f223946e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f223946e",
  null
  
)

export default component.exports